export default {
  nome: {
    value: '',
    maxlength: '100',
    required: true,
    state: null
  },
  abreviacao: {
    value: '',
    maxlength: '5',
    required: true,
    state: null
  },
  cor: {
    value: '#3B82F6',
    maxlength: '7',
    required: true,
    state: null
  },
  corTexto: {
    value: '#FFFFFF',
    maxlength: '7',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/board/tag/components/add/tag-form.js